const axios = require('axios').default;

const instance = axios.create({
  baseURL: 'http://www.expresoelvasquito.com.ar/utils',
});

export default instance;